define('core/TabSet',['knockout', 'underscore'], function (ko, _) {

    var Tab = function(routeConfig, title, icon, css, isActive) {
        this.routeConfig = routeConfig;
        this.title = ko.isObservable(title) ? title : ko.observable(title);
        this.icon = ko.isObservable(icon) ? icon : ko.observable(icon);
        this.css = ko.isObservable(css) ? css : ko.observable(css);
        this.isActive = isActive;
    };

    var TabSet = function(navigation, name,  tabs) {

        var activeInstruction = navigation.getRouter().activeInstruction;

        this.name = name;

        this.tabs = ko.deferredComputedArray(function () {

            return _.map(ko.unwrap(tabs), function(tabConfig) {

                var isActive = ko.deferredComputed(function () {
                    return activeInstruction() && activeInstruction().config.id === tabConfig.routeConfig.route;
                });

                return new Tab(tabConfig.routeConfig, tabConfig.title, tabConfig.icon, tabConfig.css, isActive);
            });
        });
    };

    return TabSet;
});

